import { engineComponent } from "neo-common";
import { Communication, Platforms } from "neo-games";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { UserControls } from "../Common/UserControls/UserControls";
import { HtmlController } from "../../HTMLComponents/HtmlController";
import { GameActions } from "../Common/Actions/GameActions";
import { ModuleManager } from "../../Managers/ModuleManager";
import { PickActions, PickOptions } from "../Common/Actions/PickActions";
import { PickController } from "../../GameComponents/Pick/PickController";
import { GameManager } from "../../Managers/GameManager";
import { BuyFeature } from "../Common/BuyFeature/BuyFeature";
import { PlayList } from "../../Components/Sounds/PlayList";

var GameModules = Communication.Game.GameModules;
var GameStatuses = Communication.Game.GameModuleStatus;

var PickRoundSpotStatus = Communication.Game.PickRoundSpotStatus;
var PickRoundSpotValueType = Communication.Game.PickRoundSpotValueType;

@engineComponent(ComponentTypes.HtmlElement)
export class DesktopPickUserControls extends UserControls {
    protected _controller: PickController;

    private _userControls: HTMLElement;
    private _userControls_supreme: HTMLElement;
    private _baseUserControls: HTMLElement;
    private _fsConfigurator: HTMLElement;

    public multipliersOption: PickOptions = PickOptions.Empty;
    public freespinsOption: PickOptions = PickOptions.Empty;
    public levelsOption: PickOptions = PickOptions.Empty;

    constructor() {
        super("pick");
    }

    create(node: Element): void {
        super.create(node);

        this.registerActions();

        this._userControls = document.getElementById("pickUserControls");
        this._fsConfigurator = document.getElementById("fsConfigurator");
    }

    addController(controller: PickController): void {
        this._controller = controller;
        this._controller.on(PickController.StartReceived, this.startReceived.bind(this));
        this._controller.on(PickController.SelectReceived, this.selectReceived.bind(this));
        this._controller.on(PickController.EndReceived, this.endReceived.bind(this));
        this._controller.on(PickController.AllWheelsFinished, this.allWheelsFinished.bind(this));
        this._controller.on(PickController.IntroFinished, this.introFinished.bind(this));
        this._controller.on(PickController.Intro, this.intro.bind(this));
        this._controller.on(PickController.OutroFinished, this.outroFinished.bind(this));
        this._controller.on(PickController.Outro, this.outro.bind(this));
        this._controller.on(PickController.StartFreespins, this.startFreespins.bind(this));
    }

    registerActions(): void {
        this.actions.registerActions({
            [PickActions.ActionConfirm]: false,
            [PickActions.ActionRespinFreespins]: false,
            [PickActions.ActionRespinMultipliers]: false,
            [PickActions.ActionRespinLevels]: false,
        });
    }

    initReceived(): void {
        this._userControls_supreme = document.getElementById("userControls_supreme");
        this._baseUserControls = document.getElementById("userControls");

        super.initReceived();

        this._controller.initReceived();

        if (this._userControls != null) {
            this._userControls.style.display = "none";
        }
        if (this._userControls != null && !this._userControls.classList.contains(HtmlController.DisabledClass)) {
            this._userControls.classList.add(HtmlController.DisabledClass);
        }

        BuyFeature.hideBuyFeatureIcon();
    }

    startReceived(): void {
        // ModuleManager.outroModule(GameModules.Base);
        // ModuleManager.setAutoplayAfterFeature(false);
    }

    selectReceived(): void {
        this.prepareNewGameRound();
    }

    endReceived(): void {
        // if(ModuleManager.freespinsEnabled()) {
        //     ModuleManager.enableFreespins();
        // }
    }

    dispatchAction(action: string): void {
        if (ModuleManager.pickEnabled() || ModuleManager.pickActive()) {
            if (action === GameActions.ActionSpinOrStop) {
                action = PickActions.ActionConfirm;
                // return;
            }

            if (this.actions.getActionState(action)) {
                super.dispatchAction(action);

                PlayList.play("SND_Click");
                switch (action) {
                    case PickActions.ActionConfirm:
                        this.disable();
                        this.end();
                        break;
                    case PickActions.ActionRespinFreespins:
                        if (this.freespinsOption == PickOptions.Empty) {
                            this.disable();
                            this.freespinsOption = PickOptions.Respin;
                            this._controller.select(0);
                        }
                        break;
                    case PickActions.ActionRespinMultipliers:
                        if (this.multipliersOption == PickOptions.Empty) {
                            this.disable();
                            this.multipliersOption = PickOptions.Respin;
                            this._controller.select(1);
                        }
                        break;
                    case PickActions.ActionRespinLevels:
                        if (this.levelsOption == PickOptions.Empty) {
                            this.disable();
                            this.levelsOption = PickOptions.Respin;
                            this._controller.select(2);
                        }
                        break;
                }

                HtmlController.updateActionElements(this.getAllActions());
            }
        }
    }

    start(): void {
        if (this._userControls != null) {
            this._userControls.style.display = "block";
        }
        this.actions.disableAllActions();
        HtmlController.updateActionElements(this.getAllActions());

        this.freespinsOption = PickOptions.Empty;
        this.multipliersOption = PickOptions.Empty;
        this.levelsOption = PickOptions.Empty;

        this._controller.start();
    }

    startFreespins(): void {
        if (ModuleManager.freespinsEnabled()) {
            ModuleManager.startFreespins();
        }
    }

    back(): void {
        this.disable();
        ModuleManager.endPick();
    }

    end(): void {
        this._controller.end();
    }

    initIntro(): void {
        super.initIntro();
        this._controller.initIntro();
        Platforms.Platforms.featureInit({ type: Communication.Game.GameModules.Pick });

        this.freespinsOption =
            GameManager.pickResponse.round.spots.filter((s) => <any>s.valueType == "count")[0].status ==
            PickRoundSpotStatus.Enabled
                ? PickOptions.Empty
                : PickOptions.Respin;
        this.multipliersOption =
            GameManager.pickResponse.round.spots.filter((s) => <any>s.valueType == "multiplier")[0].status ==
            PickRoundSpotStatus.Enabled
                ? PickOptions.Empty
                : PickOptions.Respin;
        this.levelsOption =
            GameManager.pickResponse.round.spots.filter((s) => <any>s.valueType == "level")[0].status ==
            PickRoundSpotStatus.Enabled
                ? PickOptions.Empty
                : PickOptions.Respin;

        if (!ModuleManager.pickEnabled() && ModuleManager.freespinsEnabled()) {
            this.disable();
        } else {
            this.prepareNewGameRound(true);

            if (this._fsConfigurator) {
                this._fsConfigurator.classList.remove(HtmlController.DisabledClass);
            }

            if (this._userControls != null) {
                this._userControls.style.display = "block";
            }

            if (this._userControls_supreme != null) {
                this._userControls_supreme.style.display = "block";
            }

            if (this._userControls != null) {
                this._userControls.classList.remove(HtmlController.DisabledClass);
            }

            if (this._baseUserControls != null) {
                this._baseUserControls.classList.remove(HtmlController.DisabledClass);
            }

            if (this._userControls_supreme != null) {
                this._userControls_supreme.classList.remove(HtmlController.DisabledClass);
            }
        }
    }

    intro(long: boolean = false): void {
        /*
        if (this._userControls != null) {
            this._userControls.classList.add(HtmlController.DisabledClass);
        }

        if (this._userControls_supreme != null) {
            this._userControls_supreme.classList.add(HtmlController.DisabledClass);
        }

        if (this._baseUserControls != null) {
            this._baseUserControls.classList.add(HtmlController.DisabledClass);
        }
 */
    }

    introFinished(): void {
        if (this._userControls_supreme != null) {
            this._userControls_supreme.style.display = "block";
        }

        if (this._userControls != null) {
            this._userControls.classList.remove(HtmlController.DisabledClass);
        }

        if (this._baseUserControls != null) {
            this._baseUserControls.classList.remove(HtmlController.DisabledClass);
        }

        if (this._userControls_supreme != null) {
            this._userControls_supreme.classList.remove(HtmlController.DisabledClass);
        }
    }

    outro(): void {
        if (this._fsConfigurator) {
            this._fsConfigurator.classList.add(HtmlController.DisabledClass);
        }

        this._controller.outro();
    }

    outroFinished(): void {
        if (this._userControls != null && !this._userControls.classList.contains(HtmlController.DisabledClass)) {
            this._userControls.classList.add(HtmlController.DisabledClass);
        }

        if (this._userControls_supreme != null) {
            this._userControls_supreme.classList.add(HtmlController.DisabledClass);
        }

        if (this._baseUserControls != null) {
            this._baseUserControls.classList.add(HtmlController.DisabledClass);
        }

        ModuleManager.introModule(GameModules.Freespins, true, GameModules.Pick);
    }

    prepareNewGameRound(init: boolean = false, allWheelsFinished: boolean = false): void {
        let enableFreespins: boolean = false;
        let enableMultipliers: boolean = false;
        let enableLevels: boolean = false;

        if (
            GameManager.pickResponse != null &&
            GameManager.pickResponse.round != null &&
            GameManager.pickResponse.round.spots != null
        ) {
            enableFreespins =
                GameManager.pickResponse.round.spots.filter((s) => <any>s.valueType == "count")[0].status ==
                PickRoundSpotStatus.Enabled;
            enableMultipliers =
                GameManager.pickResponse.round.spots.filter((s) => <any>s.valueType == "multiplier")[0].status ==
                PickRoundSpotStatus.Enabled;
            enableLevels =
                GameManager.pickResponse.round.spots.filter((s) => <any>s.valueType == "level")[0].status ==
                PickRoundSpotStatus.Enabled;
        }

        this.actions.changeActionStates({
            [PickActions.ActionConfirm]: allWheelsFinished,
            [PickActions.ActionRespinFreespins]: enableFreespins,
            [PickActions.ActionRespinMultipliers]: enableMultipliers,
            [PickActions.ActionRespinLevels]: enableLevels,
        });

        HtmlController.updateActionElements(this.getAllActions());
    }

    pickStartButton(): void {
        if (this._baseUserControls != null && this._baseUserControls.classList.contains(HtmlController.DisabledClass)) {
            this._baseUserControls.classList.remove(HtmlController.DisabledClass);
        }
    }

    allWheelsFinished(): void {
        // allWheelsFinished is called after wheels rotation done
        if (!ModuleManager.pickEnabled() && ModuleManager.freespinsEnabled()) {
            this.disable();
            this.startFreespins();
            return;
        }

        if (
            this.freespinsOption != PickOptions.Empty &&
            this.multipliersOption != PickOptions.Empty &&
            this.levelsOption != PickOptions.Empty
        ) {
            // all options were selected
            this.disable();
            this.end();
        } else {
            this.prepareNewGameRound(false, true);
            this._fsConfigurator.classList.remove(HtmlController.DisabledClass);
        }
    }

    enable(): void {
        ModuleManager.outroModule(GameModules.Base);
        ModuleManager.setAutoplayAfterFeature(false);

        // this.start();
    }

    disable(): void {
        this.actions.disableAllActions();
        HtmlController.updateActionElements(this.getAllActions());
        //this.outro();
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Desktop/DesktopPickUserControls.ts
 **/